interface IWithParams {
  [x: string]: string | boolean | undefined;
}

export const withParams = (params: IWithParams) =>
  Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");
